const actions = {
  SET_STATE: 'photobooth/SET_STATE',
  PHOTOBOOTH_ANALYTICS: 'photobooth/PHOTOBOOTH_ANALYTICS'
}

export default actions
